<script>
  import TabBar from '../lib/components/TabBar.svelte';
  import Cards from '../cards/Cards.svelte';
  import OrdererReport from '../reports/OrdererReport.svelte';
  import { t9n } from '../lib/translate';
  import { TS } from '../config/translation-keys';
  import session from '../lib/session';
  import { onMount } from 'svelte';
  import WorkerReport from '../reports/WorkerReport.svelte';
  import WorkerEarning from './WorkerEarning.svelte';

  let current_tab = 0;
  let btn_prev;
  let btn_next;
  let role;

  let tab_bar_items = [
    { name: null, icon: null, validated: true, has_used: 0 },
    { name: null, icon: null, validated: false, has_used: 0 },
  ];

  window.next_tab = () => {
    if (current_tab + 1 !== tab_bar_items.length) {
      current_tab++;
    }
  };

  window.prev_tab = () => {
    if (current_tab !== 0) {
      current_tab--;
    }
  };

  const translate_texts = () => {
    tab_bar_items[0].name = t9n(TS.NEW_ORDER_HEADER_PAY);
    tab_bar_items[1].name = t9n(TS.MENU_LABEL_REPORTS);
    btn_next = t9n(TS.TABLE_BUTTON_NEXT);
    btn_prev = t9n(TS.TABLE_BUTTON_PREV);
  };

  const init_payment_reports = () => {
    role = $session.user.last_role;
  };

  onMount(() => {
    init_payment_reports();
  });

  $: if (!!$session) {
    translate_texts();
  }

</script>

  <main>
  <div
    id='transition-outer'
    class='mdc-card wrapper fade-in transition-main'
    style='padding: 0 1rem 0 1rem;'>

    <div id='transition-inner'>

      {#if role === 'orderer'}
        <div style='margin-top: 0px'>
          <TabBar
            padding='100px'
            bind:current_tab
            bind:tab_bar_items />
        </div>

        <div class='mobile-margin' style='margin-top: 50px; margin-bottom: 24px;'>
          {#if current_tab === 0}
            <Cards/>
          {:else if current_tab === 1}
            <OrdererReport/>
          {/if}
        </div>
      {:else}
        <div style='margin-top: 0px'>
          <TabBar
            padding='100px'
            bind:current_tab
            bind:tab_bar_items />
        </div>

        <div class='mobile-margin-worker' style='margin-top: 50px; margin-bottom: 24px;'>
          {#if current_tab === 0}
            <WorkerEarning/>
          {:else if current_tab === 1}
            <WorkerReport/>
          {/if}
        </div>
      {/if}

    </div>

    <!-- Back + Next -->
    <p />
    <div style="display: flex; justify-content: flex-end; margin-bottom: 25px">
      <div style="margin-right: 10px;">
        <button
          id='prev_tab'
          onclick="prev_tab()"
          class:hide={current_tab===0}
          class:show={current_tab===1}
          class="mdc-button mdc-button--outlined margin-5">
          <span class="mdc-button__ripple" />
          {btn_prev}
        </button>
      </div>

      <button
        onclick="next_tab()"
        class:hide={current_tab===1}
        class:show={current_tab===0}
        class="mdc-button mdc-button--outlined margin-5">
        <span class="mdc-button__ripple" />
        {btn_next}
      </button>
    </div>

  </div>
</main>


<style type='text/scss'>
  /* Reset Styles
      *******************************************************/

  * {
    box-sizing: border-box;
    margin: 0;
    padding: 0;
    text-decoration: none;
  }

  main {
    display: flex;
    flex-direction: column;
    margin-top: 3rem !important;
    padding: 0.5rem 0.5rem;
    background: #ffffff8c;
    border-radius: 10px;
  }

  img {
    width: 100%;
  }

  .transition-main {
    transition: height 0.3s;
    overflow: hidden;
  }

  .tooltip-state {
    font-size: 12px;
    position: relative;
    transform: rotate(-6deg);
    top: 10px;
    left: -5px;
  }

  .tooltip-state .tooltip-top {
    position: absolute;
    z-index: 1;
    bottom: 100%;
    left: 50%;
    right: 0;
  }

  .tooltip-state .tooltip-text {
    color: #e65812;
    font-weight: 800;
    position: absolute;
    text-align: center;
    border: blue;
    border: dashed;
    border-radius: 6px !important;
    padding: 8px 8px !important;
  }

  .hide{
    display: none;
  }

  .show{
    display: block;
  }

  /* Desktop Mode
      *******************************************************/
  @media (min-width: 1025px) {
    main {
      width: 700px;
      margin: 0 auto;
      height: fit-content;
    }
  }

  /* Tablet Mode
      *******************************************************/
  @media (min-width: 769px) and (max-width: 1024px) {
    main {
      width: 90%;
      margin: 0 auto;
      height: fit-content;
    }
  }

  /* Mobile Mode
      *******************************************************/
  @media (min-width: 0) and (max-width: 768px) {
    main {
      width: 100%;
      margin: 0 auto;
      height: fit-content;
      margin-bottom: 100px;
      padding: 0;
      border-radius: 0;
    }

    .mobile-margin {
      margin-left: 50px;
    }

    .mobile-margin-worker {
      margin-left: 25px;
    }
  }
</style>
